<template>
  <div class="location">
    <div class="location__title">
      {{title}}
      <div
        @click="openDirections()"
        class="location__direction-link">
        <img src="public/ui/direction-arrow-link.png" alt="Directions Icon" />
        <div class="tooltiptext">Google Maps Directions</div>
      </div>
    </div>
    <div class="location__image" v-if="imgUrl"><img :src="'https://directus.its.rochester.edu/maps/assets/' + imgUrl" alt="location image" /></div>
    <div class="location__desc">{{desc}}</div>
  </div>
</template>

<script>
export default {
  name: 'LocationDetails',
  props: {
    title: String,
    desc: String,
    coords: Object,
    imgUrl: String
  },
  created() {
  },
  methods: {
    openDirections() {
      const lat = this.coords.coordinates[0];
      const lng = this.coords.coordinates[1];
      const url = "https://maps.google.com/?q="+lng+","+lat;
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
.location__title {
  font-weight: bold;
  position: relative;
}
.location__direction-link {
  cursor: pointer;
  width: 18px;
  height: 18px;
  float:right;
  
  img {
    width: 18px;
    height: 18px;
  }

  .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #fff;
    color: #000;
    border: 1px solid #000;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }
}


.location__direction-link:hover .tooltiptext {
  visibility: visible;
}
.location__desc {
  font-size:.9em;
}
</style>